/*
* JavaScript for Header
*/
jQuery (function ($) {

  // Declarations
  const selector = '.header';
  const $this = $(selector);
  const toggleSelector = `${selector}__toggle`;
  const backdropSelector = `${selector}__backdrop`;
  const $backdrop = $(backdropSelector);
  const $sidebar = $(`${selector}__sidebar`);
  const $mobileSubmenu = $(`${selector}__mobile-submenu`);
  const megaMenuToggleSelector = `${selector}__mega-menu-toggle`;
  const megaMenuSelectorBase = `${selector}__mega-menu--`;

  (function init() {
    addEvents();
  })();

  function addEvents() {
    $this.on('click', toggleSelector, toggleSidebar);
    $this.on('click', backdropSelector, toggleSidebar);
    $this.on('mouseenter', megaMenuToggleSelector, toggleMegaMenu);
    $this.on('mouseleave', megaMenuToggleSelector, toggleMegaMenu);
    $mobileSubmenu.on('show.bs.collapse', function () {
      $mobileSubmenu.not(this).collapse('hide');
    });
  }

  /**
   * Toggle mobile sidebar
   */
  function toggleSidebar() {
    $sidebar.toggleClass('open');
    $backdrop.toggleClass('d-none');
  }


  /**
   * Finds and opens or closes Mega Menu
   */
  function toggleMegaMenu() {
    const targetIdentifier = $(this).data('target');
    const $targetMenu = $(`${megaMenuSelectorBase}${targetIdentifier}`);

    $targetMenu.toggleClass('active');
  }
});
